import styled, { css } from 'styled-components'

import Box from '@totallymoney/ui/components/Box'
import theme from '@totallymoney/ui/theme'

export const StyledHeroWrapper = styled(Box)<{ waveColor: string }>`
    &:after {
        position: absolute;
        width: 100%;
        height: ${theme.space40};
        bottom: 0;
        display: block;
        content: '';
        transform: rotate(180deg);
        background: white;
        z-index: 2;
        left: 0;
        ${({ waveColor }) => css`
            background: transparent
                url('data:image/svg+xml,%3Csvg%20viewBox%3D%220%2070%20500%2060%22%20preserveAspectRatio%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M0%20100c244.8-40%20244.8%2040%20499.8%200v-2000H0z%22%20fill%3D%22${encodeURI(
                    waveColor
                ).replace('#', '%23')}%22%2F%3E%0A%20%20%20%20%3C%2Fsvg%3E')
                no-repeat;
        `}
        background-size: 101% 100%;
        background-position-y: center;

        ${theme.mediaMediumPlus`
            height: ${theme.space60};
        `}

        ${theme.mediaLargePlus`
            height: ${theme.space80};
        `}
    }
`
